import axios from 'axios'

// Get business data
const get = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/business`)
  return data
}

// get business sections by businessId
const getSections = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/business/${id}/sections`)
  return data
}

// Get stage from business
const getStage = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/business/${id}/stage`)
  return data
}

export {
  get,
  getSections,
  getStage
}
